import { OrderStatus } from '@dreryk/egabinet-statistics-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { PrintIconAction } from '../actions/PrintIconAction';
import { ResultsIconAction } from '../actions/ResultsIconAction';
import { DownloadCSVIconAction } from '../actions/DownloadCSVIconAction';

type ActionsCellProps = {
   readonly status: OrderStatus;
   readonly statisticsId: number;
};

export const ActionsCell = (props: ActionsCellProps): JSX.Element | null => {
   // TODO DREGAB-6635: https://dreryk.atlassian.net/browse/DREGAB-6635 uncomment code below once task is completed
   if (props.status === 'FAILED') {
      // return <DeleteIconAction />;
      return null;
   }

   if (props.status === 'IN_PROGRESS') {
      return null;
   }

   return (
      <StyledFlex>
         <PrintIconAction statisticsId={props.statisticsId} />
         <ResultsIconAction statisticsId={props.statisticsId} />
         <DownloadCSVIconAction statisticsId={props.statisticsId} />
      </StyledFlex>
   );
};
